import { useEffect, useState } from "react";
import { Platform } from "react-native";

const MAX_WIDTH_PX = 768;
const NARROW_VIEWPORT_QUERY = `(max-width: ${MAX_WIDTH_PX}px)`;

function readNarrowViewport(): boolean {
  if (Platform.OS !== "web" || typeof window === "undefined" || typeof window.matchMedia !== "function") {
    return false;
  }
  return window.matchMedia(NARROW_VIEWPORT_QUERY).matches;
}

/**
 * True on web when the layout viewport is at most {@link MAX_WIDTH_PX}px wide.
 * Used to gate send-review “in-scroll gradient while input focused” so wide desktop windows
 * keep the default fixed footer; narrow windows use focus + `visualViewport` (see screen).
 */
export function useWebNarrowViewport(): boolean {
  const [matches, setMatches] = useState(readNarrowViewport);

  useEffect(() => {
    if (Platform.OS !== "web" || typeof window === "undefined" || typeof window.matchMedia !== "function") {
      return;
    }
    const mql = window.matchMedia(NARROW_VIEWPORT_QUERY);
    const sync = () => setMatches(mql.matches);
    sync();
    if (typeof mql.addEventListener === "function") {
      mql.addEventListener("change", sync);
      return () => mql.removeEventListener("change", sync);
    }
    mql.addListener(sync);
    return () => mql.removeListener(sync);
  }, []);

  return matches;
}
